// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#buttons[data-v-4c2d49d5]{display:flex;justify-content:space-between;margin:auto}.narrower[data-v-4c2d49d5]{width:600px;margin:auto}", ""]);
// Exports
module.exports = exports;
